import { apiPost } from '@/store/api';
import { GatResponseResult } from '@/types/GatResponseResult';

export async function connectProformaPortcall(callId: string, proformaId: string | number, sednaJobId?: string): Promise<GatResponseResult<undefined>> {
    if (callId && proformaId) {
        const result: GatResponseResult<any> = await apiPost(`proforma/${proformaId}/connect-portcall/${callId}`,
            {
                PORTCALL_SEDNA_JOB_ID: sednaJobId ?? null,
            });
        return result;
    }

    const response: GatResponseResult<undefined> = {
        message: 'Missing required parameters: callId or proformaId',
        syncChanges: null,
        resultType: 0,
        resultCategory: 2, // Warning
    };
    return response;
}
